<template>
  <a
      :href="href"
      :target="target"
      :class="[
        'inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold',
        'shadow-lg shadow-black/40 transition-colors duration-200',
        variant === 'secondary'
          ? 'border border-golden-grass/50 bg-golden-grass/10 text-golden-grass-200 backdrop-blur-md hover:bg-golden-grass/20 hover:border-golden-grass/80'
          : 'bg-golden-grass text-marshland-950 hover:bg-golden-grass-400',
      ]"
  >
    <slot></slot>
    <UIcon v-if="icon" :name="icon" class="w-4.5 h-4.5 flex-shrink-0"/>
  </a>
</template>

<script setup lang="ts">
defineProps<{
  href: string
  target?: string
  icon?: string
  variant?: 'primary' | 'secondary'
}>()
</script>
